const { current } = useMagicKeys();

export function wheneverOnly(source, cb: Function) {
	return whenever(source, () => {
		if (current.size > 1) return;
		cb();
	});
}
